import React, { useState } from "react";
import { withRouter } from 'react-router-dom';
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { RoutableLink } from '../../react/RoutableLink';
import { Sizes, Colors } from '../../ts/enums';
import css from './index.module.scss';

const ToggleSearchFlyout = () => {
    let currentState = document.body.getAttribute('data-searchopen') === 'true';
    let searchButton = document.getElementById('searchBtn');
    // @ts-ignore
    document.body.setAttribute('data-searchopen', !currentState);
    searchButton.setAttribute('aria-expanded', `${!currentState}`);

    // Update tabindexes for keyboard tabbing, -1 is 'not tabbable' when search form is closed, 0 is 'tabbable' when open
    let allSearchActions = document.body.querySelectorAll(`div[class*='EduBrandBar_searchFlyout'] *[tabindex]`);
    allSearchActions.forEach(function (action) {
        action.setAttribute('tabIndex', currentState ? '-1' : '0');
    });
    if (!currentState) {
        // Is open
        document.body.addEventListener('keyup', keyToCloseSearchFlyout);
    }
    else {
        // Is closed
        document.body.removeEventListener('keyup', keyToCloseSearchFlyout);
    }
    
}

const keyToCloseSearchFlyout = (e) => {
    // Escape || Tab outside searchFlyout
    if (e.which === 27 || (e.which === 9 && e.target.closest(`div[class*='EduBrandBar_searchFlyout']`) === null)) {
        ToggleSearchFlyout();
    }
}

const keyToCloseDropdown = (e) => {
    // Escape || Tab outside dropdown
    if (e.which === 27 || (e.which === 9 && e.target.closest('[data-infodropdownisopen]') === null)) {
        ToggleInfoDropdown();
    }
}

const clickToCloseDropdown = (e) => {
    if (!e.target.classList.contains(css.infoDropdownButton)) {
        ToggleInfoDropdown();
    }
}

const ToggleInfoDropdown = () => {
    let dropdownContainer = document.querySelector('*[data-infodropdownisopen');
    let currentState = dropdownContainer.getAttribute('data-infodropdownisopen') === 'true';
    // @ts-ignore
    dropdownContainer.setAttribute('data-infodropdownisopen', !currentState);
    dropdownContainer.querySelector(`.${css.infoDropdownButton}`).setAttribute('aria-expanded', `${!currentState}`);


    if (!currentState) {
        // Is open
        document.body.addEventListener('click', clickToCloseDropdown);
        document.body.addEventListener('keyup', keyToCloseDropdown);
    }
    else {
        // Is closed
        document.body.removeEventListener('click', clickToCloseDropdown);
        document.body.removeEventListener('keyup', keyToCloseDropdown);
        let navMenu = document.getElementById('header');
         navMenu.setAttribute('data-mobilenavisopen', 'false');
    }
}

const EduBrandBar = ({ fields, history, ResetNavHandler }) => {
    const children = fields?.children ? fields?.children : [null, null];
    const [leftLinks, rightLinks] = children;
    const leftLinksFields = leftLinks?.fields?.children;
    const rightLinksFields = rightLinks?.fields?.children;
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearch = () => {
        if (fields?.useGoogleSearch?.value){
            history.push(`${fields.searchPageLink.value.href}#gsc.q=${searchQuery}`);
        }
        else if (fields.searchPageLink?.value?.href) {
            history.push(`${fields.searchPageLink.value.href}#q=${searchQuery}`);
        }
    }

    const handleChange = (e) => {
        setSearchQuery(e.target.value)
    }

    return (
        <div className={css.container}>
            <div className='single-col-inner'>
                <div className={css.innerContainer}>
                    <div className={`${css.navList} ${css.leftBar}`}>
                        {
                            leftLinksFields?.length > 0 &&
                            <LinkContainer links={leftLinksFields} ResetNavHandler={ResetNavHandler} />
                        }
                    </div>
                    <div className={`${css.navList} ${css.rightBar}`}>
                        {
                            rightLinksFields?.length > 0 &&
                            <LinkContainer links={rightLinksFields} ResetNavHandler={ResetNavHandler} />
                        }

                        {/* Search */}
                        {
                            fields?.searchIcon?.value
                                ? <button id="searchBtn" aria-label='Search' aria-expanded={false} className={css.searchButton} onClick={() => ToggleSearchFlyout()}>
                                    <i className={`fa fa-${fields?.searchIcon?.value}`} />
                                </button>
                                : null
                        }
                    </div>
                </div>
            </div>
            <div className={css.searchFlyout}>
                <form className={css.searchForm} data-formtype='search' onSubmit={handleSearch}>
                    <div className={css.searchBarContainer}>
                        <label htmlFor='searchBar' className={css.searchBarLabel}>Search UChicago</label>
                        <input id='searchBar'
                            className={css.searchBar}
                            type='search'
                            aria-label='Search UChicago'
                            placeholder={fields?.globalSearchboxPlaceholderText?.value}
                            tabIndex={-1}
                            onChange={handleChange}
                            onFocus={(e) => e.target.placeholder = ''}
                            onBlur={(e) => e.target.placeholder = fields?.globalSearchboxPlaceholderText?.value}
                            value={searchQuery} />
                    </div>
                    <div className='fa fa-search'>
                        <input type='submit' value='Submit Search' tabIndex={-1} onSubmit={ResetNavHandler} />
                    </div>
                    <div className="PeopleDirectoryLink">
                        <a href="http://directory.uchicago.edu" className="peopleLink" target="_blank" rel="noopener noreferrer" data-chevron="true"><span className="linkText">Search for People</span></a>
                    </div>
                    
                </form>
                <button  onClick={() => ToggleSearchFlyout()}
                    aria-label='Close search form'
                    className={`${css.close} fa fa-close`}
                    tabIndex={-1} />
            </div>
        </div>
    )
}

// Takes a list of links and spits out left/right container markup
const LinkContainer = ({ links, ResetNavHandler }) => {
    return (
        <ul className={css.linkContainer}>
            {
                links?.map((link, index) => (
                    (link?.fields?.title?.value && link?.fields?.children?.length > 0) ?
                        // Dropdown
                        <li className={`${css.infoDropdownContainer} ${css.linkListItem}`} 
                            id={"info-menu"}
                            data-infodropdownisopen={false}
                            key={`brandBar-link-dropdown-${index}`}>
                            <Text className={css.infoDropdownButton}
                                field={link.fields.title}
                                tag='button'
                                aria-expanded={false}
                                onClick={ToggleInfoDropdown} 
                                aria-controls="info-menu"/>
                            <ul className={css.infoDropdownList}>
                                {
                                    link.fields.children?.map((dropdownLink, index) =>
                                        (dropdownLink?.fields?.link?.value?.href && dropdownLink?.fields?.linkText?.value) &&
                                        <li className={css.infoDropdownListItem} key={`infodropdown-${index}`}>
                                            <RoutableLink field={dropdownLink.fields.link}
                                                data-chevron={true} data-size={Sizes.SMALL}
                                                data-color={Colors.GREY}
                                                className={css.infoDropdownLink}>
                                                <Text field={dropdownLink.fields.linkText} />
                                            </RoutableLink>
                                        </li>
                                    )
                                }
                            </ul>
                        </li>
                        :
                        // Regular link
                        (link?.fields?.link?.value?.href && link?.fields?.linkText?.value) &&
                        <li className={css.linkListItem} key={`brandBar-link-dropdown-${index}`}>
                            <RoutableLink field={link.fields.link}
                                onClick={ResetNavHandler}
                                className={`${css.brandBarLink}${link.fields.highlight?.value === true ? ` ${css.linkHighlight}` : ''}`}
                                key={`brandBar-link-${index}`}>
                                <Text field={link.fields.linkText} />
                            </RoutableLink>
                        </li>
                ))
            }
        </ul>
    )
}

export default withRouter(EduBrandBar);